import { useRef, useEffect } from 'react';
import { useThree, useFrame } from '@react-three/fiber';

const Camera = ({ position = [0, 10, 10], zoom = 1, fov = 60, ...props }) => {
  const ref = useRef();
  const { set, size } = useThree();

  useEffect(() => {
    if (ref.current) {
      ref.current.position.set(...position);
      ref.current.zoom = zoom;
      ref.current.updateProjectionMatrix();
      set({ camera: ref.current });
    }
  }, [position, zoom, set]);

  useFrame(() => {
    if (ref.current) {
      ref.current.updateMatrixWorld();
    }
  });

  // useEffect(() => {
  //   const handleResize = () => {
  //     const aspect = size.width / size.height;
  //     ref.current.aspect = aspect;
  //     ref.current.updateProjectionMatrix();
  //   };

  //   window.addEventListener('resize', handleResize);
  //   handleResize(); // Initialize with correct aspect ratio

  //   return () => window.removeEventListener('resize', handleResize);
  // }, [size]);

  useEffect(() => {
    const handleResize = () => {
      if (!ref.current) return; // ← bail out if camera isn’t mounted yet
      const aspect = size.width / size.height;
      ref.current.aspect = aspect;
      ref.current.updateProjectionMatrix();
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // now safe
    return () => window.removeEventListener('resize', handleResize);
  }, [size.width, size.height]); // only rerun when these change

  return <perspectiveCamera ref={ref} fov={fov} {...props} />;
};

export default Camera;
